export default "__VITE_ASSET__BBgbZVG7__"